const treatmentFilters = {
    state: {
      filters: {}
    },
    mutations: {
      // Mutation to set a filter based on the label
      setTreatmentFilter(state, { label, value }) {
        state.filters[label] = value;
      },
      resetTreatmentFilters(state) {
        state.filters = {};
      }
    },
    actions: {
      // Action to apply a filter
      applyTreatmentFilter({ commit }, { label, value }) {
        commit('setTreatmentFilter', { label, value });
      },
      resetTreatmentFilters({ commit }) {
        commit('resetTreatmentFilters');
      }
    },
    getters: {
      getTreatmentFilter: (state) => (label) => {
        return state.filters[label] || null;
      }
    }
  };
  
  export default treatmentFilters;
  